module.exports = __webpack_public_path__ + "img/ysgxm.d9494145.jpg";